module.exports = __webpack_public_path__ + "img/3-5.06d39943.svg";